
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns74bd6879a9af6ccb1a885fd9555d5ed5en from './en.yaml'
            i18n.addResourceBundle('en', '74bd6879a9af6ccb1a885fd9555d5ed5', flattenObject(ns74bd6879a9af6ccb1a885fd9555d5ed5en), true, true);
        
        export default '74bd6879a9af6ccb1a885fd9555d5ed5';
    